module.exports = __webpack_public_path__ + "img/revoke.10c4fe6a.png";